import {

	AUTOMATIC_REPORT_FAILURE,
	AUTOMATIC_REPORT_REQUEST,
	AUTOMATIC_REPORT_SUCCESS,
	UPDATE_AUTOMATIC_REPORT_FAILURE,
	UPDATE_AUTOMATIC_REPORT_REQUEST,
	UPDATE_AUTOMATIC_REPORT_SUCCESS,
} from "./automaticReportSettingsTypesConstants";

export const automaticReportSettingsReducer = (
	initialState = {
	},
	action
) => {
	switch (action.type) {

		case AUTOMATIC_REPORT_REQUEST:
			return {
				...initialState,
				loading: true,

			};
		case AUTOMATIC_REPORT_SUCCESS:
			return {
				...initialState,
				data: action.payload.data,
				loading: false,
			};

		case AUTOMATIC_REPORT_FAILURE:
			return {
				...initialState,
				loading: false,
				getError: action.payload,
			};
		case UPDATE_AUTOMATIC_REPORT_REQUEST:
			return {
				...initialState,
				updateLoading: true,

			};
		case UPDATE_AUTOMATIC_REPORT_SUCCESS:
			return {
				...initialState,
				updateData: action.payload.data,
				updateLoading: false,
			};

		case UPDATE_AUTOMATIC_REPORT_FAILURE:
			return {
				...initialState,
				updateLoading: false,
				updateError: action.payload,
			};

		default:
			return initialState;
	}
};
